<div class="container">
  <div class="radio-group">
    <input type="radio" name="hourly-group-type" value="1" id="hourly-count" checked="true" (change)="changeGroupType(1)" />
    <label for="hourly-count" class="ml-1">{{ translator.translate('count') | async }}</label>
    <input type="radio" name="hourly-group-type" value="2" id="hourly-average" (change)="changeGroupType(2)" />
    <label for="hourly-average" class="ml-1">{{ translator.translate('average') | async }}</label>
  </div>
  <app-breakdown-linechart-widget [config]="widgetData"></app-breakdown-linechart-widget>
</div>
